<template>
  <div class="page_ page_fixed_form_control_wrapper_ vasco_page_" :class="{ ens_fix_: currentLang != 1 }">
    <div class="top_">
      <div class="clearfix_">
        <div class="pc-left">
          <h4>{{ productInfo.productName }}</h4>
          <p class="pre_">
            <span>{{ productInfo.ageRange }}</span>
            <span class="mrg_l24_">{{ $t('addPolicy.ab') }}</span>
          </p>
        </div>
        <div v-show="sumPremium > 0 && $route.query.productCode != 'BOCI18'" class="pc-right">
          <a-button class="bold_" type="primary" ghost>{{ $t('addPolicy.ac') }}{{ sumPremium }} {{ $t('unit.d') }}</a-button>
        </div>
      </div>
    </div>
    <a-form :form="form" @change="handleCountPremium" @submit="handleFormSubmit" class="horizontal_item_ fix_mrg_">
      <div>
        <h5>{{ $t('addPolicy.h1') }}</h5>
      </div>
      <div class="basic_info_">
        <a-row>
          <a-col :span="24">
            <a-form-item :label="$t('addPolicy.k')" class="radio-id">
              <a-radio-group
                @change="handleTypeChange"
                v-decorator="[
                  'type',
                  {
                    initialValue: insuredType,
                    rules: [{ message: $t('input.b'), required: true }],
                  },
                ]"
              >
                <a-radio value="I">{{ $t('addPolicy.i') }}</a-radio>
                <a-radio v-if="!productInfo.noCType" value="C">{{ $t('addPolicy.j') }}</a-radio>
              </a-radio-group>
              <a v-if="productInfo.showInvoiceModal" @click="invoiceVisible = true">{{ $t('addPolicy.o') }}？</a>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="insuredType == 'C'">
            <a-form-item label="纳税人类别">
              <a-select
                v-decorator="[
                  'taxpayercertificatetype',
                  {
                    rules: [{ required: true, message: $t('input.b') }],
                  },
                ]"
                :placeholder="$t('input.b')"
                class="w300_"
              >
                <a-select-option value="1">小规模纳税人</a-select-option>
                <a-select-option value="2">增值税一般纳税人</a-select-option>
                <a-select-option value="3">非增值税纳税人</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <a-form-item :label="$t('addPolicy.l')" v-if="userParams.productCode != 'BOCI19'" class="radio-id">
          <a-radio-group
            v-if="productInfo && !productInfo.relationshipType"
            v-decorator="[
              'relationship',
              {
                initialValue: '1',
                rules: [{ required: true, message: $t('input.b') }],
              },
            ]"
          >
            <a-radio value="1">{{ $t('addPolicy.m') }}</a-radio>
            <a-radio value="5">{{ $t('addPolicy.n') }}</a-radio>
          </a-radio-group>
          <a-select
            style="margin-right: 8px"
            class="w140_"
            v-else
            v-decorator="[
              'relationship',
              {
                initialValue: '1',
                rules: [{ required: true, message: $t('input.b') }],
              },
            ]"
          >
            <a-select-option v-for="item in relationships" :key="item.value" :value="item.value">
              {{ item.name }}
            </a-select-option>
          </a-select>
          <a v-if="productInfo.showHowPolicy" @click="modalB = true">{{ $t('addPolicy.p') }}？</a>
        </a-form-item>
        <!-- <a-form-item label="计划类型">
                            <a-radio-group defaultValue="1">
                                <a-radio :value="0">单次</a-radio>
                                <a-radio :value="1">全年保障</a-radio>
                            </a-radio-group>
                        </a-form-item> -->
        <a-form-item :label="$t('addPolicy.h')">
          <a-select
            @change="handlePlanSelect"
            v-decorator="[
              'planCode',
              {
                rules: [
                  {
                    required: true,
                    message: $t('input.b') + $t('addPolicy.h'),
                  },
                ],
              },
            ]"
            :placeholder="$t('input.b')"
            class="w500_"
          >
            <a-select-option v-for="item in planOptions" :key="item.code" :value="item.code">{{ item.name }} </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('productDetail.b')">
          <a-range-picker
            :disabledDate="disabledDate"
            :open="openDateSelect"
            @openChange="handleOpenChange"
            @calendarChange="calendarChange"
            @change="rangePicker"
            v-decorator="[
              'rangeDate',
              {
                rules: [
                  {
                    required: true,
                    message: $t('input.b') + $t('productDetail.b'),
                  },
                ],
              },
            ]"
            :placeholder="[$t('input.c'), $t('input.d')]"
          >
          </a-range-picker>
          <span style="margin-left: 24px" v-if="planOffsetDay">{{ fullYearPlan ? $t('labels.d') : `${$t('unit.c')} ${planOffsetDay} ${$t('unit.a')}` }}</span>
        </a-form-item>
        <a-form-item :label="$t('addPolicy.u')" v-if="userParams.productCode != 'BOCI19'">
          <a-input class="w300_" :disabled="productInfo.disabledDest" v-model="productInfo.destination" :readOnly="true"></a-input>
        </a-form-item>
        <a-form-item v-show="sumPremium > 0 && $route.query.productCode == 'BOCI18'">
          <a-button class="bold_" type="primary" ghost>{{ $t('addPolicy.ac') }}{{ sumPremium }} {{ $t('unit.d') }}</a-button>
        </a-form-item>
      </div>
      <template v-if="insuredType == 'I'">
        <h5>{{ $t('addPolicy.j2') }}</h5>
        <div class="personal_">
          <a-form-item :label="$t('addPolicy.a2')">
            <a-input
              v-decorator="[
                'name',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('input.a') + $t('addPolicy.a2'),
                    },
                  ],
                },
              ]"
              class="w257_"
              :placeholder="$t('input.a') + $t('addPolicy.a2')"
            ></a-input>
          </a-form-item>
          <a-form-item :label="$t('addPolicy.b2')">
            <a-select
              :placeholder="$t('input.b')"
              @change="c => handleIdTypeSelectChange(c)"
              v-decorator="[
                'idType',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('input.a') + $t('addPolicy.b2'),
                    },
                  ],
                },
              ]"
              class="w257_"
            >
              <a-select-option v-for="item in idTypeOptions" :key="item.value" :value="item.value">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :label="$t('addPolicy.c2')">
            <a-input
              @blur="handleIdCardBlur"
              v-decorator="[
                'idNumber',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('input.a') + $t('addPolicy.c2'),
                    },
                    {
                      validator: (rule, value, callback) => checkIDNumber(rule, value, callback, 'idType'),
                    },
                  ],
                },
              ]"
              class="w257_"
              :placeholder="$t('input.a')"
            ></a-input>
          </a-form-item>
          <a-form-item label="证件有效止期" v-if="userParams.productCode == 'BOCI19'">
            <a-date-picker
              placeholder="证件有效止期"
              v-decorator="[
                'invalidate',
                {
                  rules: [{ required: true, message: '请输入证件有效止期' }],
                },
              ]"
            />
          </a-form-item>
          <a-form-item :label="$t('addPolicy.d2')">
            <a-date-picker
              v-decorator="[
                'birthDate',
                {
                  initialValue: tpBirthDate,
                  rules: [
                    {
                      required: true,
                      message: $t('input.b') + $t('addPolicy.d2'),
                    },
                  ],
                },
              ]"
              :placeholder="$t('input.b')"
            ></a-date-picker>
          </a-form-item>
          <a-form-item :label="$t('addPolicy.e2')">
            <a-select
              :placeholder="$t('input.b')"
              v-decorator="[
                'gender',
                {
                  rules: [{ required: true, message: $t('input.b') + $t('input.i') }],
                },
              ]"
              class="w257_"
            >
              <a-select-option v-for="item in sexOptions" :key="item.value" :value="item.value">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :label="$t('addPolicy.f2')">
            <a-input
              v-decorator="[
                'telephone',
                {
                  rules: [
                    { required: true, message: $t('input.a') + $t('input.g') },
                    {
                      pattern: /\d{11}/,
                      message: $t('input.a') + $t('input.h') + $t('input.g'),
                    },
                  ],
                },
              ]"
              class="w257_"
              :placeholder="$t('input.a')"
            ></a-input>
          </a-form-item>
          <a-form-item :label="$t('addPolicy.e3')">
            <a-input
              v-decorator="[
                'email',
                {
                  rules: [{ required: true, message: $t('input.a') + $t('input.e') }],
                },
              ]"
              class="w257_"
              :placeholder="$t('input.a')"
            ></a-input>
          </a-form-item>
          <a-form-item v-if="userParams.productCode == 'BOCI19'" label="省市区">
            <a-cascader
              placeholder="请选择"
              class="w257_"
              @change="(value, label) => labelChange(value, 'pacCode', label)"
              v-decorator="[
                'projectaddress',
                {
                  rules: [{ required: true, message: '请选择省市区' }],
                },
              ]"
              :options="addressOptions"
              :fieldNames="{
                label: 'text',
                value: 'value',
                children: 'children',
              }"
            />
          </a-form-item>
          <a-form-item :label="$t('addPolicy.f3')">
            <a-input
              v-decorator="[
                'address',
                {
                  rules: [
                    { required: true, message: $t('input.a') + $t('input.j') },
                    {
                      validator: (rule, value, callback) => checkAddress(rule, value, callback),
                    },
                  ],
                },
              ]"
              class="w257_"
              :placeholder="$t('input.a')"
            ></a-input>
          </a-form-item>
        </div>
      </template>
      <template v-else>
        <h5>{{ $t('addPolicy.k2') }}</h5>
        <div class="personal_">
          <a-form-item :label="$t('addPolicy.a2')">
            <a-input
              v-decorator="[
                'name',
                {
                  rules: [{ required: true, message: $t('input.a') + '企业名称' }],
                },
              ]"
              class="w257_"
              :placeholder="$t('input.a')"
            ></a-input>
          </a-form-item>
          <a-form-item :label="$t('addPolicy.b2')">
            <a-select
              :placeholder="$t('input.b')"
              v-decorator="[
                'idType',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('input.b') + $t('addPolicy.b2'),
                    },
                  ],
                },
              ]"
              class="w257_"
            >
              <a-select-option v-for="item in companyIdTypeOptions" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :label="$t('addPolicy.c2')">
            <a-input
              v-decorator="[
                'idNumber',
                {
                  rules: [{ required: true, message: $t('input.a') + $t('input.f') }],
                },
              ]"
              class="w257_"
              :placeholder="$t('input.f')"
            ></a-input>
          </a-form-item>
          <a-form-item :label="$t('addPolicy.f2')">
            <a-input
              class="w257_"
              type="number"
              v-decorator="[
                'telephone',
                {
                  rules: [{ required: true, message: $t('input.a') + $t('input.g') }],
                },
              ]"
              :placeholder="$t('input.a')"
            ></a-input>
          </a-form-item>
          <a-form-item :label="$t('addPolicy.e3')">
            <a-input
              v-decorator="[
                'email',
                {
                  rules: [{ required: true, message: $t('input.a') + $t('input.e') }],
                },
              ]"
              class="w257_"
              :placeholder="$t('input.a')"
            ></a-input>
          </a-form-item>
          <a-form-item :label="$t('addPolicy.f3')">
            <a-input
              v-decorator="[
                'address',
                {
                  rules: [
                    { required: true, message: $t('input.a') + $t('input.j') },
                    {
                      validator: (rule, value, callback) => checkAddress(rule, value, callback),
                    },
                  ],
                },
              ]"
              class="w257_"
              :placeholder="$t('input.a')"
            ></a-input>
          </a-form-item>
        </div>
      </template>
      <h5>{{ $t('addPolicy.h5') }}</h5>
      <div class="personal_">
        <a-form-item :label="$t('addPolicy.l')" v-if="userParams.productCode == 'BOCI19'" class="radio-id">
          <a-select
            style="margin-right: 8px"
            class="w140_"
            @change="relationshipChange"
            v-decorator="[
              'relationship',
              {
                rules: [{ required: true, message: $t('input.b') }],
              },
            ]"
          >
            <a-select-option v-for="item in relationships" :key="item.value" :value="item.value">
              {{ item.name }}
            </a-select-option>
          </a-select>
          <a v-if="productInfo.showHowPolicy" @click="modalB = true">{{ $t('addPolicy.p') }}？</a>
        </a-form-item>
        <a-form-item :label="$t('addPolicy.a5')">
          <a-input
            v-decorator="[
              'bbr_name',
              {
                rules: [{ required: true, message: $t('input.a') + $t('input.k') },
                { validator: validateName }],
              },
            ]"
            class="w257_"
            @change="c => changePinyin(c.target.value, 'bbr_name')"
            :placeholder="$t('input.a')"
          ></a-input>
        </a-form-item>
        <div style="overflow: hidden">
          <a-form-item style="float: left" :label="$t('addPolicy.f5')">
            <a-input
              v-decorator="[
                'bbr_name_pinyin',
                {
                  rules: [{ required: true, message: $t('input.a') + $t('input.py') }],
                },
              ]"
              class="w257_"
              :placeholder="$t('input.a')"
            ></a-input>
          </a-form-item>
          <p style="position: relative; top: 12px; left: 10px; color: red; font-size: 12px; float: left">{{ $t('input.pyt') }}</p>
        </div>
        <a-form-item :label="$t('addPolicy.c5')">
          <a-select
            :placeholder="$t('input.b')"
            @change="c => handleIdTypeSelectChange(c, 'bbr_')"
            v-decorator="[
              'bbr_idType',
              {
                rules: [
                  {
                    required: true,
                    message: $t('input.b') + $t('addPolicy.c5'),
                  },
                ],
              },
            ]"
            class="w257_"
          >
            <a-select-option v-for="item in idTypeOptions" :key="item.value" :value="item.value">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('addPolicy.d5')">
          <a-input
            @blur="handleIdCardBlur('bbr_')"
            v-decorator="[
              'bbr_idNumber',
              {
                rules: [
                  { required: true, message: $t('input.a') + $t('input.f') },
                  {
                    validator: (rule, value, callback) => checkIDNumber(rule, value, callback, 'bbr_idType'),
                  },
                ],
              },
            ]"
            class="w257_"
            :placeholder="$t('input.f')"
          ></a-input>
        </a-form-item>
        <a-form-item label="证件有效期" v-if="userParams.productCode == 'BOCI19'">
          <a-range-picker
            @change="handleCountPremium"
            v-decorator="[
              'bbr_idExpiry',
              {
                rules: [
                  {
                    required: true,
                    message: '请选择证件有效期',
                  },
                ],
              },
            ]"
            :placeholder="['请选择证件有效期', '请选择证件有效期']"
          >
          </a-range-picker>
        </a-form-item>
        <a-form-item :label="$t('addPolicy.f2')">
          <a-input
            class="w257_"
            type="phone"
            v-decorator="[
              'bbr_telephone',
              {
                rules: [
                  { required: true, message: $t('input.a') + $t('input.g') },
                  { pattern: /\d{11}/, message: '请输入正确的手机号' },
                ],
              },
            ]"
            :placeholder="$t('input.a')"
          ></a-input>
        </a-form-item>
        <a-form-item :label="$t('addPolicy.b5')">
          <a-select
            :placeholder="$t('input.b')"
            @change="handleCountPremium"
            v-decorator="[
              'bbr_gender',
              {
                rules: [
                  {
                    required: true,
                    message: $t('input.b') + $t('addPolicy.b5'),
                  },
                ],
              },
            ]"
            class="w257_"
          >
            <a-select-option v-for="item in sexOptions" :key="item.value" :value="item.value">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('addPolicy.e5')">
          <a-date-picker
            @change="handleCountPremium"
            v-decorator="[
              'bbr_birthDate',
              {
                initialValue: tpBirthDate,
                rules: [
                  {
                    message: $t('input.b') + $t('addPolicy.e5'),
                    required: true,
                  },
                ],
              },
            ]"
            :placeholder="$t('input.b')"
          ></a-date-picker>
        </a-form-item>
        <a-form-item v-if="userParams.productCode == 'BOCI19'" label="省市区">
          <a-cascader
            placeholder="请选择"
            class="w257_"
            @change="(value, label) => labelChange(value, 'pacCode1', label)"
            v-decorator="[
              'bbr_projectaddress',
              {
                rules: [{ required: true, message: '请选择省市区' }],
              },
            ]"
            :options="addressOptions"
            :fieldNames="{
              label: 'text',
              value: 'value',
              children: 'children',
            }"
          /><a-checkbox @change="onChangeaddres" style="margin-left: 20px"> 同投保人 </a-checkbox>
        </a-form-item>
        <a-form-item :label="$t('addPolicy.f3')" v-if="userParams.productCode == 'BOCI19'">
          <a-input
            v-decorator="[
              'bbr_address',
              {
                rules: [
                  { required: true, message: $t('input.a') + $t('input.j') },
                  {
                    validator: (rule, value, callback) => checkAddress(rule, value, callback),
                  },
                ],
              },
            ]"
            class="w257_"
            :placeholder="$t('input.a')"
          ></a-input>
        </a-form-item>
      </div>

      <div :gutter="24" class="footer_" style="justify-content: left" v-if="userParams.productCode == 'BOCI19'">
        <div class="title_">
          <div class="cutoff_"></div>
        </div>
        <a-checkbox :disabled="!agreementAllRead" @change="onChangeyueduBtn" style="margin-bottom: 20px">
          {{ $t('addPolicy.a6') }}
          <fileView :plancode="planCode"></fileView>
        </a-checkbox>
        <a-button class="pc-right btn_default_" html-type="submit" type="primary">{{ $t('buttons.d') }} </a-button>
      </div>
      <div class="footer_" v-else>
        <a-form-item class="clearfix_">
          <div class="yuedu-btn">
            <span>
              <a-radio-group
                v-decorator="[
                  'agreement',
                  {
                    initialValue: agreed,
                  },
                ]"
              >
                <a-radio value="1"></a-radio>
              </a-radio-group>
            </span>
            <span>
              {{ $t('addPolicy.a6') }}
            </span>
            <span>
              <a target="_blank" :href="productInfo.insuranceFile">
                {{ $t('addPolicy.b6') }}
              </a>
            </span>
            <span>
              {{ $t('addPolicy.d6') }}
            </span>
            <span
              ><a @click="modalC = true">{{ $t('addPolicy.c6') }}</a></span
            >
          </div>
          <a-button class="pc-right btn_default_" html-type="submit" type="primary">{{ $t('buttons.d') }} </a-button>
        </a-form-item>
      </div>
    </a-form>
    <a-modal :footer="false" class="modal_" @cancel="invoiceVisible = false" :visible="invoiceVisible" :title="$t('addPolicy.o')">
      <div>
        {{ $t('modal.a') }}
      </div>
      <p class="btn_wrap_">
        <a-button class="btn_default_" @click="invoiceVisible = false" type="primary">{{ $t('buttons.c') }} </a-button>
      </p>
    </a-modal>
    <a-modal :footer="false" class="modal_" @cancel="modalB = false" :visible="modalB" :title="$t('addPolicy.p')">
      <div>
        {{ $t('modal.b') }}
      </div>
      <p class="btn_wrap_">
        <a-button class="btn_default_" @click="modalB = false" type="primary">{{ $t('buttons.c') }}</a-button>
      </p>
    </a-modal>
    <insurDecla @confirm="confirmAgreement" :p="cPath" :lang="currentLang" :visible.sync="modalC" />
    <a-modal :afterClose="handlePayModalClose" class="myModal_ myNoticeModal_" width="600px" :title="payModalTitle" v-model="payVisible">
      <div class="notice_">
        <img v-if="payQrcode" style="margin: 0 auto; display: block" :src="payQrcode" />
        <div v-else>
          需要支付：<span style="color: #fe8f2d">¥ {{ sumPremium || 0 }}</span>
        </div>
      </div>
      <template slot="footer">
        <a-button @click="payVisible = false" class="btn_color" type="danger" ghost> 支付遇到问题 </a-button>
        <a-button @click="handlePaySuccess" class="btn_color" type="primary"> 已支付成功 </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
// import dictOptions from '../dictOptions'
const dictOptions = window.viewsdictOptions;
import insurDecla from './components/insurDecla';
import policyMixin from './mixins/policy';
import addPolicyMixin from './mixins/addPolicy';
import fileView from './components/fileView';
import moment from 'moment';

export default {
  data() {
    return {
      invoiceVisible: false,
      modalB: false,
      modalC: false,
      insuredType: 'I',
      form: this.$form.createForm(this),
      companyIdTypeOptions: dictOptions.commonIdTypeOfCompanyOptions,
      planOffsetDay: '',
      sumPremium: '0.00',
      openDateSelect: false,
      fullYearPlan: false,
      yueduBtn: false, //阅读开关
      agreed: '',
      payState: '',
      planCode: '',
      pacCode: [],
      pacCode1: [],
      userParams: {
        productCode: '',
      },
      validateName: null
    };
  },
  computed: {
    addressOptions() {
      //地址code
      let ArrCode = '';
      let twoArrCode = '';
      let threeCode = '';
      let dataArr = window.addrescode19;
      dataArr &&
        dataArr.forEach(e => {
          if (ArrCode.indexOf(e.value) > -1) {
            e['disabled'] = true;
          }
          e.children.forEach(element => {
            if (twoArrCode.indexOf(element.value) > -1) {
              element['disabled'] = true;
            }
            element.children.forEach(elements => {
              if (threeCode.indexOf(elements.value) > -1) {
                elements['disabled'] = true;
              }
            });
          });
        });
      return dataArr;
    },
    agreementAllRead() {
      //协议文件是否全部已读
      return this.$store.state.insureDoc.agreementAllRead;
    },
    relationships() {
      let relationships = dictOptions.relationshipSDOptions;
      let relationshipsEn = dictOptions.relationshipSDOptionsEn;
      if (this.productInfo.relationships) {
        const fn = item => this.productInfo.relationships.indexOf(item.value) > -1;
        relationships = relationships.filter(fn);
        relationshipsEn = relationshipsEn.filter(fn);
      }
      return this.currentLang == 1 ? relationships : relationshipsEn;
    },
    idTypeOptions() {
      let idTypeOptions = dictOptions.idTypeOptions;
      let idTypeOptionsEn = dictOptions.idTypeOptionsEn;
      if (this.productInfo.idTypes) {
        const fn = item => this.productInfo.idTypes.indexOf(item.value) > -1;
        idTypeOptions = idTypeOptions.filter(fn);
        idTypeOptionsEn = idTypeOptionsEn.filter(fn);
      }
      return this.currentLang == 1 ? idTypeOptions : idTypeOptionsEn;
    },
    sexOptions() {
      return this.currentLang == 1 ? dictOptions.sexOptions : dictOptions.sexOptionsEn;
    },
  },
  mixins: [policyMixin, addPolicyMixin],
  components: {
    insurDecla,
    fileView,
  },
  mounted() {
    let { productCode, u } = this.$route.query;
    if(productCode === 'BOCI11') {
      if(u) {
        this.$router.push({path:'/astp/home',query:{c:u}})
        return
      }
      this.$router.push({path:'/astp/home'})
      return
    }
    this.productInfo.destination = '涵盖所有申根国家（inc. All Schengen Countries)';
    if (this.userParams.productCode == 'BOCI19') {
      this.$store.dispatch('getMaterial', { mdProductCode: productCode, webUserId: u, _this: this }); //获取客户告知书承包等投保文件
    }
    this.initData()
  },
  methods: {
    initData() {
      // 校验被保人姓名
      this.validateName = (rule, val, callback) => {
        const isZhCn = /^[\u4E00-\u9FA5\uf900-\ufa2d]+$/
        const isEn = /^[a-zA-Z\s]+$/
        if (val !== "" && !isZhCn.test(val) && !isEn.test(val)) {
          callback(new Error(this.$t('input.nameTip')));
        }
        callback()
      };
    },
    labelChange(value, type, label) {
      if (type == 'pacCode') {
        this.pacCode = label;
      }
      if (type == 'pacCode1') {
        this.pacCode1 = label;
      }
    },
    relationshipChange(val) {
      if (val == 1) {
        let name = this.form.getFieldValue('name');
        let gender = this.form.getFieldValue('gender');
        let birthDate = this.form.getFieldValue('birthDate');
        let idType = this.form.getFieldValue('idType');
        let idNumber = this.form.getFieldValue('idNumber');
        let telephone = this.form.getFieldValue('telephone');
        let address = this.form.getFieldValue('address');
        let projectaddress = this.form.getFieldValue('projectaddress');
        this.pacCode1 = this.pacCode;
        this.changePinyin(name, 'bbr_name');
        this.form.setFieldsValue({
          bbr_name: name,
          bbr_gender: gender,
          bbr_birthDate: birthDate,
          bbr_idType: idType,
          bbr_idNumber: idNumber,
          bbr_telephone: telephone,
          bbr_address: address,
          bbr_projectaddress: projectaddress,
        });
      }
    },
    onChangeaddres(val) {
      console.log(val);
      let address = this.form.getFieldValue('address');
      let projectaddress = this.form.getFieldValue('projectaddress');
      this.pacCode1 = this.pacCode;
      this.form.setFieldsValue({
        bbr_address: address,
        bbr_projectaddress: projectaddress,
      });
    },
    handleCountPremium() {
      this.$nextTick(()=>{
      let bbr_name = this.form.getFieldValue('bbr_name');
      let bbr_name_pinyin = this.form.getFieldValue('bbr_name_pinyin');
      let bbr_gender = this.form.getFieldValue('bbr_gender');
      let bbr_birthDate = this.form.getFieldValue('bbr_birthDate');
      let bbr_idType = this.form.getFieldValue('bbr_idType');
      let bbr_idNumber = this.form.getFieldValue('bbr_idNumber');
      let bbr_idExpiry = this.form.getFieldValue('bbr_idExpiry');
      let relationship = this.form.getFieldValue('relationship');
      let bbr_telephone = this.form.getFieldValue('bbr_telephone');
      let planCode = this.plancode;
      if (bbr_name && bbr_name_pinyin && bbr_name_pinyin && bbr_gender && bbr_birthDate && bbr_idType && bbr_idNumber && relationship && bbr_telephone && bbr_idExpiry) {
        const data = [
          {
            name: bbr_name,
            linkmanname: bbr_name_pinyin,
            gender: bbr_gender,
            birthDate: bbr_birthDate.format('YYYY-MM-DD'),
            idType: bbr_idType,
            idNumber: bbr_idNumber,
            relationship: relationship,
            mobile: bbr_telephone,
            salInsuredExt: {
              idExpiryStart: bbr_idExpiry[0] && bbr_idExpiry[0].format('YYYY-MM-DD'),
              idExpiryEnd: bbr_idExpiry[1] && bbr_idExpiry[1].format('YYYY-MM-DD'),
            },
          },
        ];
        const arr = [...data];
        const params = [];
        if (planCode && (this.offsetDay || this.fullYearPlan) && arr.length > 0) {
          let day = this.fullYearPlan ? 1 : this.offsetDay;
          let dayType = this.fullYearPlan ? 'y' : 'd';
          arr.forEach(item => {
            // 有出生日期
            if (item.birthDate) {
              params.push({
                birthDay: item.birthDate,
                dayType,
                days: day,
                effectiveDate: this._effectiveDate,
                planCode: planCode,
                insName: item.name,
                insEnName: item.linkmanname,
                salInsuredExt: item.salInsuredExt,
              });
            }
          });
        }
        console.log('debug -> ', params, planCode);
        if (params.length < 1) {
          return;
        }
        console.log(`开始请求接口进行计算 -> `, params);
        this.$api
          .calPremium(params)
          .then(res => res.data)
          .then(data => {
            let sum = data.content;
            this.sumPremium = sum;
          })
          .catch(() => {
            this.totalPremium = '';
          });
      }
    })
    },
    changePinyin(value) {
      // const isZhCn = /^[\u4E00-\u9FA5\uf900-\ufa2d]+$/
      // const isEn = /^[a-zA-Z\/s]+$/
      var pinyin = pinyinUtil.getPinyin(value, '');
      this.form.setFieldsValue({
        bbr_name_pinyin: pinyin.toUpperCase(),
      });
      this.handleCountPremium();
    },
    confirmAgreement() {
      this.agreed = '1';
    },
    handleTypeChange(e) {
      this.insuredType = e.target.value;
      this.form.setFieldsValue({
        idType: '',
      });
    },
    //理解并阅读
    onChangeyueduBtn(e) {
      this.yueduBtn = e.target.checked;
    },
    handleFormSubmit(e) {
      e && e.preventDefault();
      this.form.validateFields((err, values) => {
        console.log('Received values of form: ', err, values);
        if (!err) {
          if (values.type == 'I' && moment().diff(values.birthDate, 'years') < 18) {
            this.$message.error('投保人年龄少于18岁，不能参与投保，请修改后再试！');
            return;
          }
          if (!values.agreement && this.userParams.productCode != 'BOCI19') {
            this.modalC = true;
            //   this.$message.error('请确认已阅读并同意保险条款投保声明')
            return;
          }
          if (!this.yueduBtn && this.userParams.productCode == 'BOCI19') {
            this.$message.warning('请确认已充分阅读、理解并同意《保险条款》《投保须知》《责任免除》', 2);
            return;
          }
          let defaultCreator, creator;
          let localCreator = sessionStorage.getItem('pathname');
          if (localCreator && localCreator == '/axa/astp/home2') {
            creator = '845453';
          } else {
            defaultCreator = /ssish/.test(location.href) || /yutai365/.test(location.href) ? '39726' : '1';
            creator = sessionStorage.getItem('creator') || (this.userParams && this.userParams.userId) || defaultCreator;
          }

          this.postData = {
            salInsuredList: [
              {
                name: this.userParams.productCode == 'BOCI19'?values.bbr_name:values.bbr_name + values.bbr_name_pinyin,
                linkmanname: values.bbr_name_pinyin,
                gender: values.bbr_gender,
                birthDate: values.bbr_birthDate.format('YYYY-MM-DD'),
                idType: values.bbr_idType,
                idNumber: values.bbr_idNumber,
                relationship: values.relationship,
                mobile: values.bbr_telephone,
                address: values.bbr_address,
              },
            ],
            salPolicy: {
              destination: this.productInfo.destination,
              effectiveDate: values.rangeDate[0].format('YYYY-MM-DD'),
              expireDate: values.rangeDate[1].format('YYYY-MM-DD'),
              planCode: values.planCode,
              totalPremium: this.sumPremium,
              creator,
              productCode: (this.userParams && this.userParams.productCode) || 'axatp002',
            },
            salPolicyHolder: {
              type: values.type,
              taxpayercertificatetype: values.taxpayercertificatetype,
              name: values.name,
              telephone: values.telephone,
              idType: values.idType,
              idNumber: values.idNumber,
              birthDate: values.birthDate && values.birthDate.format('YYYY-MM-DD'),
              email: values.email,
              invalidate: values.invalidate ? values.invalidate.format('YYYY-MM-DD') : '', //values.invalidate,
              gender: values.gender,
              address: values.address,
            },
            salPolicyHolderExt: {},
          };
          if (this.userParams.productCode == 'BOCI19') {
            this.postData.salPolicyHolder.province = this.pacCode[0].text; //省
            this.postData.salPolicyHolder.city = this.pacCode[1].text; //市
            this.postData.salPolicyHolder.district = this.pacCode[2].text; //区
            this.postData.salPolicyHolder.addresscode = `${this.pacCode[0].value}-${this.pacCode[1].value}-${this.pacCode[2].value}`;
            this.postData.salPolicyHolderExt = {
              idExpiryStart: values.invalidate ? values.invalidate.format('YYYY-MM-DD') : '', //有效期
            };
            this.postData.salInsuredList[0].salInsuredExt = {
              idExpiryStart: values.bbr_idExpiry[0] && values.bbr_idExpiry[0].format('YYYY-MM-DD'),
              idExpiryEnd: values.bbr_idExpiry[1] && values.bbr_idExpiry[1].format('YYYY-MM-DD'),
              liveAddress: `${this.pacCode1[0].text}-${this.pacCode1[1].text}-${this.pacCode1[2].text}`,
              expand1: `${this.pacCode1[0].value}-${this.pacCode1[1].value}-${this.pacCode1[2].value}`,
            };
          }
          console.log('form submit ->', 'postdData', this.postData);
          this._isToPay = true;
          this.saveOrder(this.postData);
        }
      });
    },
    handlePaySuccess() {
      if (this.payState === '1') {
        return;
      }
      this.$message.warn('如果您已支付，请稍等，保单生成中！');
    },
    saveOrder(data) {
      const openPayUrl = url => {
        window.open(url);
      };
      const startLoop = policyId => {
        let i = 100;
        let si = setInterval(() => {
          i--;
          if (i < 1) {
            clearInterval(si);
          }
          this.$api
            .queryPolicy({
              policyId,
            })
            .then(res => res.data)
            .then(data => {
              const { status, remark } = data.content.salPolicy;
              if (status === '1') {
                this.payState = '1';
                clearInterval(si);
                this.$router.push({
                  name: 'insuresuccess',
                  query: {
                    policyId: policyId,
                    u: this.$route.query.u,
                  },
                });
              } else if (status == '-1') {
                this.$message.error(remark);
                clearInterval(si);
                this.$router.push({
                  name: 'insureError',
                  params: {
                    error: remark || '服务端异常！',
                  },
                });
              }
            })
            .catch(err => {
              clearInterval(si);
              this.$router.push({
                name: 'insureError',
                params: {
                  error: err.data.returnMsg || '服务端异常！',
                },
              });
            });
        }, 3000);
        this.paySi = si;
      };
      let startToPay = () => {
        let policyId = this._policyId;
        if (this._isToPay) {
          if (this.companyType == 2) {
            this.$api
              .icyPay(policyId)
              .then(res => res.data)
              .then(data => {
                this.payVisible = true;
                this.payModalTitle = '请前往支付';
                startLoop(policyId);
                const url = data.content.payUrl;
                openPayUrl(url);
                this._payUrl = url;
                let st = setTimeout(() => {
                  this._payUrl = '';
                  clearTimeout(st);
                }, 3000);
              })
              .finally(() => {
                this._isToPay = false;
              });
          } else {
            this.$api
              .pay(policyId)
              .then(res => res.data)
              .then(data => {
                // window.open(data.payUrl)
                import('jr-qrcode').then(jrQrcode => {
                  // 模块方法调用，传入字符串，获取 base64 编码的图片 URL
                  var imgBase64 = jrQrcode.getQrBase64(data.content.payUrl);
                  this.payQrcode = imgBase64;
                  this.payVisible = true;
                  startLoop(policyId);
                });
                // window.location.href = data.payUrl
              })
              .finally(() => {
                this._isToPay = false;
              });
          }
        } else {
          this.$message.success('保存成功');
        }
      };
      // 有保单id直接开始支付
      if (this._policyId && this._isToPay) {
        if (this._payUrl) {
          openPayUrl(this._payUrl);
          return;
        }
        startToPay();
        return;
      } else if (this._policyId) {
        data.policyId = this._policyId;
      }
      if (!this._isToPay) {
        this.onSave = true;
      } else if (!this.sumPremium) {
        this.$message.info('保费未计算完成，请确认好保费再试！');
        return;
      }
      this.$api
        .saveOrder(data)
        .then(res => res.data)
        .then(data => {
          const policyId = data.content;
          this._policyId = policyId;
          if (window.clairvoyanceRecord) {
            clairvoyanceRecord.finish({
              policyId: policyId,
            });
          }
          startToPay();
        })
        .finally(() => {
          this.onSave = false;
        });
    },
  },
};
</script>
<style scoped>
/* 移动端  */
@media all and (max-width: 750px) {
  .ant-form-item >>> .ant-form-item-label {
    margin-top: 1.8667vw !important;
  }

  .radio-id >>> .ant-form-item-label {
    margin-top: 0px !important;
  }
}
</style>
<style lang="scss" scoped>
/* 移动端  */
@media all and (max-width: 750px) {
  .yuedu-btn {
    display: flex;
    align-items: center;
  }

  .ant-radio-group {
    display: block;
  }

  .mrg_l24_ {
    margin-left: 9.6vw;
  }

  .bold_ {
    font-weight: 600;
  }

  // 弹窗
  .modal_ {
    .btn_wrap_ {
      margin-top: 7.4667vw;
      display: flex;
      justify-content: center;
    }
  }

  .page_ {
    .pre_ {
      white-space: pre-wrap;
    }

    .top_ {
      padding: 7.4667vw 12.6667vw 7.4667vw 6.6667vw;
      background: #fff;
      margin-top: 5.8667vw;

      span {
        color: #394553;
        font-size: 3.2vw;
      }
    }

    .footer_ {
      background: #fff;
      border-top: 1px solid #f8f8f8;
      padding: 4.1333vw 16vw 10.9333vw 6.9333vw;
      margin-bottom: 6.6667vw;
    }

    .w500_ {
      width: 100%;
      max-width: 57.3333vw;
    }

    .w300_ {
      width: 100%;
      max-width: 57.3333vw;
    }

    .w257_ {
      width: 100%;
      max-width: 57.3333vw;
    }

    .w140_ {
      width: 100%;
      max-width: 57.3333vw;
    }

    .mrg_l8_ {
      margin-left: 2.1333vw;
    }

    h5 {
      font-size: 3.7333vw;
      line-height: 4.5333vw;
      border-left: 0.8vw solid #ff3e18;
      margin-left: 6.9333vw;
      margin: 3.2vw 0;
      padding-left: 4.8vw;
    }

    .basic_info_,
    .personal_ {
      padding: 9.0667vw 6.9333vw;
      background: #fff;
    }
  }
}

/* PC端 */
@media all and (min-width: 751px) {
  .pc-left {
    float: left;
  }

  .pc-right {
    float: right;
  }

  .mrg_l24_ {
    margin-left: 36px;
  }

  .bold_ {
    font-weight: 600;
  }

  // 弹窗
  .modal_ {
    .btn_wrap_ {
      margin-top: 28px;
      display: flex;
      justify-content: center;
    }
  }

  .page_ {
    .pre_ {
      white-space: pre-wrap;
    }

    .top_ {
      padding: 28px 47px 28px 25px;
      background: #fff;
      margin-top: 22px;

      span {
        color: #394553;
        font-size: 12px;
      }
    }

    .footer_ {
      background: #fff;
      border-top: 1px solid #f8f8f8;
      padding: 31px 60px 41px 26px;
      margin-bottom: 50px;
    }

    .w500_ {
      width: 403px;
    }

    .w300_ {
      width: 360px;
    }

    .w257_ {
      width: 257px;
    }

    .w140_ {
      width: 140px;
    }

    .mrg_l8_ {
      margin-left: 8px;
    }

    h5 {
      font-size: 14px;
      line-height: 17px;
      border-left: 3px solid #ff3e18;
      margin-left: 26px;
      margin: 12px 0;
      padding-left: 18px;
    }

    .basic_info_,
    .personal_ {
      padding: 34px 26px;
      background: #fff;
    }

    .personal_ {
    }
  }
}
</style>